import script from "./area-project-view-details.vue?vue&type=script&setup=true&lang=js"
export * from "./area-project-view-details.vue?vue&type=script&setup=true&lang=js"

import "./area-project-view-details.vue?vue&type=style&index=0&id=4d4b5aa0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d4b5aa0"]])

export default __exports__